import { useEffect } from 'react';

/**
 * Custom hook to detect clicks outside a specified element
 * @param ref - React ref of the element to monitor for outside clicks
 * @param callback - Function to execute when an outside click is detected
 */
const useOutsideClick = (
  ref: React.RefObject<HTMLElement>,
  callback: () => void
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
};

export default useOutsideClick;
